<template>
  <div class="case">
    <div  v-if="isScrolled9">
      <Header/>
    </div>
<div style="height: 5em;"></div>
    <!-- Breadcrumbs -->

    <div class="Breadcrumbs">

      <div class="box">

        <a href='/' class=''>首页</a> &gt; <a @click="goCase">新闻资讯</a>
      </div>

    </div>



    <!-- blog -->

    <div class="blog">

      <div class="box">

        <div class="blog-menu" >
          <ul>
            <li class=""><div  @click="news1('行业新闻')"><a >行业新闻</a></div></li>
            <li class=""><div  @click="news1('技术动态')"><a >技术动态</a></div></li>
          </ul>
        </div>

        <div class="blog-list">
          <ul style="margin-top: 50px" v-for="item in articles" :key="item.id">
            <li class="wow fadeInUp move1">
              <div class="img"><a ><img :src="item.coverImage" alt=""></a></div>
              <div @click="detail(item)" class="tbox">
                <a ><h3 class="t1">{{item.title}}<span><img style="margin-right: 15px;margin-top: -1px" src="https://www.yasubit.com/template/pc/skin/images/icon14.png" alt="">{{ formatDate(item.publishTime) }}</span></h3></a>
                <div class="t2">   
                  <div style="margin-top: 20px;line-height: 2" v-html="item.summary || item.content"></div>
                </div>
                <a class="more">查看详情</a>
              </div>
            </li>
          </ul>
        </div>

        <!-- pagelist -->
        <div class="pagelist">
          共<strong>{{ Math.ceil(total / pageSize) }}</strong>页 <strong>{{ total }}</strong>条
          <div class="pagination">
            <a href="javascript:;" @click="changePage(currentPage - 1)" v-if="currentPage > 1">上一页</a>
            <a href="javascript:;" 
               v-for="page in totalPages"
               :key="page"
               :class="{ active: page === currentPage }"
               @click="changePage(page)">
              {{ page }}
            </a>
            <a href="javascript:;" @click="changePage(currentPage + 1)" v-if="currentPage < totalPages">下一页</a>
          </div>
        </div>

      </div>

    </div>

    <Footer/>
  </div>

</template>
<script>

import Header from "@/views/header.vue";
import Banner from "../components/Banner";
import Footer from "@/views/footer.vue";
export default {
  components: {
    Header,
    Banner,
    Footer
  },
  data() {
    return {
      isScrolled9: true,
      articles: [],
      total: 0,
      currentCategory: '行业新闻',
      loading: true,
      currentPage: 1,
      pageSize: 10
    };
  },
  created() {
    document.title = '新闻资讯_智慧林';
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll9);
    this.getData();
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize);
    }
  },
  methods:{
    formatDate(timestamp) {
      return new Date(timestamp).toLocaleDateString();
    },
    goCase(){
      this.$router.push({path:"case"})
    },
    handleScroll9() {
      const scrollY = window.scrollY || window.pageYOffset;
      const dis = 100;
      if (scrollY > dis) {
        this.isScrolled9 = false;
      } else {
        this.isScrolled9 = true;
      }
    },
    news1(category){
      this.currentCategory = category;
      this.currentPage = 1; // Reset to first page when changing category
      this.getData();
    },
    detail(item){
      sessionStorage.setItem('articleDetail', JSON.stringify(item));
      this.$router.push({
        name: 'text1',
        params: { a: item.id }
      });
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.getData();
      }
    },
    getData() {
      const params = {
        category: this.currentCategory,
        page: this.currentPage,
        pageSize: this.pageSize
      };

      this.$http.get('yasubit/articles/query', { params })
        .then(response => {
          const { data } = response;
          if (data.code === 200) {
            this.articles = data.rows;
            this.total = data.total;
          }
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    }
  }
};
</script>

 <style lang="scss" scoped>

 .move1 {
   opacity: 0; // 初始时透明度为0，隐藏元素
   animation: fadeIn 1s forwards, moveUp 1.2s forwards; // 1s 表示动画持续时间，forwards 表示动画结束后保持最终状态
 }


 @keyframes moveUp {
   to {
     transform: translateY(-50px); // 向上移动 px
   }
 }

 @keyframes fadeIn {
   to {
     opacity: 1; // 最终透明度为1，显示元素
   }
 }

 #movingBox {
   transition: transform 0.5s ease; // 添加过渡效果
 }

 .bounce-animation {
   animation: bounce 2s infinite;
 }

 @keyframes bounce {
   0%,
   20%,
   50%,
   80%,
   100% {
     transform: translateY(0); // 初始位置和结束位置
   }

   40% {
     transform: translateY(-15px); // 上抬的高度，可以根据需要修改
   }

   60% {
     transform: translateY(-15px); // 下压的高度，可以根据需要修改
   }
 }


 .between{

   display: flex;
   flex-direction: row;
   justify-content: space-between;
 }

 .center{
   display: flex;align-items: center; text-align: center;justify-content: center
 }
 .one-third{
   width: 33.333333%;
   height: 50px;
   background-color: pink;
 }
 .one-five{
   display: flex;align-items: center; text-align: center;justify-content: center;flex-direction: column;
   width: 20%;
   height: 50px;

 }



 .case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  //background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}

.pagination {
  margin-top: 20px;
  text-align: center;
  
  a {
    display: inline-block;
    padding: 5px 10px;
    margin: 0 5px;
    border: 1px solid #ddd;
    color: #666;
    text-decoration: none;
    
    &:hover {
      background-color: #f5f5f5;
    }
    
    &.active {
      background-color: #1890ff;
      color: white;
      border-color: #1890ff;
    }
  }
}
</style>